import React from 'react';

const SlidesContextEdit = React.createContext();
const SlidesContextStudent = React.createContext();

export { SlidesContextEdit, SlidesContextStudent };
